import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaCalendarAlt, FaUsers, FaTools, FaHandshake } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel';

function ProjetDetail() {
  const { id } = useParams();
  const [projet, setProjet] = useState(null);
  const [evenements, setEvenements] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProjet = async () => {
      try {
        const response = await axios.get(`https://www.clublfit.org/api/projet/${id}`);

        let imageUrl = null;
        if (response.data.Url_IMG_Projet) {
          imageUrl = response.data.Url_IMG_Projet;
        } else if (response.data.Photo_Projet && response.data.Photo_Projet.data) {
          try {
            const blob = new Blob([new Uint8Array(response.data.Photo_Projet.data)], { type: 'image/png' });
            imageUrl = URL.createObjectURL(blob);
          } catch (error) {
            console.error('Erreur création blob image projet :', error);
          }
        }

        setProjet({ ...response.data, imageUrl });

        const evenements = response.data.Evenements || [];
        setEvenements(evenements);
      } catch (err) {
        setError('Erreur lors de la récupération des informations du projet');
      }
    };

    fetchProjet();
  }, [id]);

  if (error) {
    return <div className="container text-center text-danger mt-5">{error}</div>;
  }

  if (!projet) {
    return <div className="container text-center mt-5">Chargement des informations du projet...</div>;
  }

  const renderEvenement = (event) => {
    const redondant = event.redondant_Evenement !== null && event.redondant_Evenement !== '0' && event.redondant_Evenement !== 0 && event.redondant_Evenement !== '';

    const debut = event.Date_Debut ? new Date(event.Date_Debut).toLocaleDateString() : '';
    const fin = event.Date_Fin ? new Date(event.Date_Fin).toLocaleDateString() : '';
    const heureDebut = event.Heure_Debut ? event.Heure_Debut.substring(0, 5) : '--:--';
    const heureFin = event.Heure_Fin ? event.Heure_Fin.substring(0, 5) : '--:--';

    if (redondant && event.Jour && event.Date_Debut !== event.Date_Fin) {
      return `${event.Nom_Evenement} - ${event.Lieu}, chaque ${event.Jour} du ${debut} au ${fin} de ${heureDebut} à ${heureFin}`;
    }

    if (event.Date_Debut === event.Date_Fin) {
      return `${event.Nom_Evenement} - ${event.Lieu}, le ${debut} de ${heureDebut} à ${heureFin}`;
    }

    return `${event.Nom_Evenement} - ${event.Lieu}, tous les jours du ${debut} au ${fin} de ${heureDebut} à ${heureFin}`;
  };

  return (
    <div className="container my-5">
      <div className="row">
        <div className="col-md-6 order-md-1">
          <h1 className="display-4 mb-4 text-primary">{projet.Nom_Projet}</h1>
          <p className="lead">{projet.Description_Projet}</p>

          {projet.Nom_Club && (
            <div className="mb-4">
              <h5>Le Club {projet.Nom_Club} est responsable du projet</h5>
            </div>
          )}

          {projet.Objectif_Projet && (
            <div className="my-4">
              <h4>Objectif du Projet</h4>
              <p>{projet.Objectif_Projet}</p>
            </div>
          )}

          {projet.Date_Debut_Projet && projet.Date_Fin_Projet && (
            <div className="my-3 d-flex align-items-center">
              <FaCalendarAlt className="me-2 text-secondary" />
              <span>
                {`Du ${new Date(projet.Date_Debut_Projet).toLocaleDateString()} au ${new Date(projet.Date_Fin_Projet).toLocaleDateString()}`}
              </span>
            </div>
          )}

          {projet.NB_Participant_Projet && (
            <div className="my-3 d-flex align-items-center">
              <FaUsers className="me-2 text-secondary" />
              <span>{projet.NB_Participant_Projet} participants</span>
            </div>
          )}

          {projet.Matos_Projet && (
            <div className="my-3 d-flex align-items-start">
              <FaTools className="me-2 text-secondary mt-1" />
              <span>{projet.Matos_Projet}</span>
            </div>
          )}

          {projet.Partenaire_Projet && (
            <div className="my-3 d-flex align-items-start">
              <FaHandshake className="me-2 text-secondary mt-1" />
              <span>{projet.Partenaire_Projet}</span>
            </div>
          )}

          {evenements.length > 0 && (
            <div className="my-4">
              <h4>Événements associés</h4>
              {evenements.map((event, index) => (
                <div key={index} className="my-3 d-flex align-items-center">
                  <FaCalendarAlt className="me-2 text-secondary" />
                  <span>{renderEvenement(event)}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="col-md-6 order-md-2">
          <img
            src={projet.imageUrl}
            alt={projet.Nom_Projet}
            className="img-fluid rounded shadow-sm"
            style={{ width: '850px', height: '450px', objectFit: 'cover' }}
            onError={(e) => e.target.style.display = 'none'}
          />
        </div>
      </div>
    </div>
  );
}

export default ProjetDetail;
